export const CALENDAR_SLOTS_RENDERED = 48;
export const GUTTER_WIDTH_PERCENT = 2.5;
